// Shared VAT/match display helpers (DRY across Anagrafica, Sales, Acquisti, Marginalità)
export const VAT_OPTIONS = ["22", "10", "5", "4", "0 esente", "0 fuori campo"];

export const formatVatRate = (v) => {
  v = (v ?? "").toString().trim();
  if (!v) return "—";
  return /^\d+$/.test(v) ? `${v}%` : v;
};

export const MATCH_LABELS = {
  supplier_code: "Cod. fornitore",
  internal_code: "Cod. interno",
  description: "Descrizione",
  description_fuzzy: "Descrizione (simile)",
  new: "Nuovo prodotto",
};

export const MATCH_COLORS = {
  supplier_code: "bg-emerald-100 text-emerald-800",
  internal_code: "bg-sky-100 text-sky-800",
  description: "bg-stone-100 text-stone-700",
  description_fuzzy: "bg-violet-100 text-violet-800",
  new: "bg-amber-100 text-amber-800",
};
